import React from 'react';
import Header from '../header/Header';
import Footer from '../footer/Footer';

interface PageShellProps {
  children: React.ReactNode;
  /** Page background. Defaults to the same grey LandingScreen uses behind the login card. */
  background?: string;
  /** Vertical alignment of the content inside <main>. */
  align?: 'center' | 'start';
}

/**
 * Header + Footer wrapper.
 *
 * This app has no global layout — every screen renders its own <Header /> and
 * <Footer />. The login form gets them because LandingScreen wraps it
 * (LandingScreen.tsx), so any route that renders a page *directly* has to
 * supply the same shell or the chrome disappears halfway through a flow.
 *
 * Deliberately applied at the route level rather than inside the page
 * components: LoginPage is also rendered by LandingScreen, which already wraps
 * it, and putting the shell in the page would render Header/Footer twice there.
 */
const PageShell: React.FC<PageShellProps> = ({ children, background = '#f8f9fa', align = 'center' }) => (
  <div className="min-h-screen flex flex-col" style={{ backgroundColor: background }}>
    <Header />
    <main
      className={`flex-grow flex flex-col w-full ${
        align === 'center' ? 'items-center justify-center' : 'items-center justify-start'
      }`}
    >
      {children}
    </main>
    <Footer />
  </div>
);

export default PageShell;
